import { Box, Typography } from "@bca/ui-library";
import React from "react";
import { DEFAULT_PURCHASES_PARAMETERS } from "../../pages";

const NormalText = ({ text }) => (
  <Typography
    variant="h5"
    m={0}
    textAlign={{
      mobile: "center",
      desktop: "left",
    }}
    display="inline"
  >
    {text}
  </Typography>
);
const BlueText = ({ text }) => (
  <>
    <NormalText text="“" />
    <Typography
      variant="h5"
      m={0}
      textAlign={{
        mobile: "center",
        desktop: "left",
      }}
      color="secondary-teal"
      display="inline"
    >
      {text}
    </Typography>
    <NormalText text="” " />
  </>
);

const NoResultsMessage = ({
  purchasesUrlQueryParams,
  selectedFilterLabel,
  appliedCheckboxes,
}) => {
  const getDefaultSection = () => (
    <>
      <NormalText text="purchases" />
    </>
  );
  const getVrmSection = () => (
    <>
      <NormalText text="purchases matching " />
      {purchasesUrlQueryParams.q !== "" && (
        <BlueText text={`${purchasesUrlQueryParams.q}`} />
      )}
      {appliedCheckboxes.map((additionalFilter, index) => (
        <BlueText key={index} text={`${additionalFilter.filterKey}`} />
      ))}
    </>
  );
  const getFilterSection = () => (
    <>
      <BlueText text={`${selectedFilterLabel}`} />
    </>
  );
  const hasVrm = purchasesUrlQueryParams.q !== DEFAULT_PURCHASES_PARAMETERS.q;
  const hasAdditionalFilters = appliedCheckboxes.length > 0;
  const isDefault = !(hasVrm || hasAdditionalFilters);
  return (
    <Box
      css={`
        @media (max-width: 768px) {
          text-align: center;
        }
      `}
    >
      <NormalText text="You don’t have any " />
      {isDefault && getDefaultSection()}
      {!isDefault && getVrmSection()}
      <NormalText text=" for the last " />
      {getFilterSection()}
    </Box>
  );
};

export default NoResultsMessage;
